var React = require('react');

function DownloadFile (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m51.477 66.891h-2.9531l-13.969-13.973 2.9453-2.9453 12.5 12.5 12.5-12.5 2.9453 2.9453z","key":0}),React.createElement("path",{"d":"m47.918 37.5h4.168v25h-4.168z","key":1}),React.createElement("path",{"d":"m33.332 75h33.332v4.168h-33.332z","key":2}),React.createElement("path",{"d":"m31.242 29.168h-14.574v-4.168h14.574c1.1523 0 2.0898-0.9375 2.0898-2.0898v-14.578h4.168v14.574c0 3.4531-2.8086 6.2617-6.2578 6.2617z","key":3}),React.createElement("path",{"d":"m83.332 100h-66.664c-4.5977 0-8.332-3.7383-8.332-8.332l-0.003907-68.77 0.60938-1.4766 20.816-20.816 1.4766-0.60547h52.098c4.5977 0 8.332 3.7383 8.332 8.332v83.332c0.003907 4.5977-3.7344 8.3359-8.332 8.3359zm-70.832-76.238v67.906c0 2.3008 1.8711 4.168 4.168 4.168h66.668c2.3008 0 4.168-1.8672 4.168-4.168l-0.003906-83.336c0-2.2969-1.8672-4.168-4.168-4.168l-51.234 0.003907z","key":4})]));
}

DownloadFile.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = DownloadFile;

DownloadFile.default = DownloadFile;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/download-file.svg
// module id = 385
// module chunks = 0